import React, { useState } from 'react';
import './Maths.css';

const topics = {
  "Natural Numbers": {
    definition: "Natural numbers are the counting numbers starting from 1.",
    examples: [
      "Example 1: 5 is a natural number.",
      "Example 2: 10 is a natural number."
    ],
    problem: {
      question: "What is the sum of the first 5 natural numbers?",
      solution: "The first 5 natural numbers are 1, 2, 3, 4, and 5. Sum = 1 + 2 + 3 + 4 + 5 = 15."
    }
  },
  "Whole Numbers": {
    definition: "Whole numbers include all natural numbers and zero.",
    examples: [
      "Example 1: 0, 1, 2, 3, ...",
      "Example 2: 7 is a whole number."
    ],
    problem: {
      question: "What is the product of the first 4 whole numbers?",
      solution: "The first 4 whole numbers are 0, 1, 2, and 3. Product = 0 x 1 x 2 x 3 = 0."
    }
  },
  "Integers": {
    definition: "Integers include all positive and negative whole numbers and zero.",
    examples: [
      "Example 1: -3, -2, -1, 0, 1, 2, 3",
      "Example 2: 5 and -5 are integers."
    ],
    problem: {
      question: "What is the result of adding -3 and 7?",
      solution: "-3 + 7 = 4."
    }
  },
  "Fractions and Decimals": {
    definition: "Fractions represent parts of a whole, and decimals represent fractions in decimal form.",
    examples: [
      "Example 1: 1/2 and 0.5",
      "Example 2: 3/4 and 0.75"
    ],
    problem: {
      question: "Convert the fraction 3/4 to a decimal.",
      solution: "3 divided by 4 = 0.75."
    }
  },
  "Addition": {
    definition: "Addition is combining two numbers to get a sum.",
    examples: [
      "Example 1: 5 + 3 = 8",
      "Example 2: 10 + 2 = 12"
    ],
    problem: {
      question: "What is 15 + 7?",
      solution: "15 + 7 = 22."
    }
  },
  "Subtraction": {
    definition: "Subtraction is finding the difference between two numbers.",
    examples: [
      "Example 1: 8 - 3 = 5",
      "Example 2: 15 - 6 = 9"
    ],
    problem: {
      question: "What is 20 - 4?",
      solution: "20 - 4 = 16."
    }
  },
  "Multiplication": {
    definition: "Multiplication is repeated addition of the same number.",
    examples: [
      "Example 1: 4 x 3 = 12",
      "Example 2: 5 x 6 = 30"
    ],
    problem: {
      question: "What is 7 x 5?",
      solution: "7 x 5 = 35."
    }
  },
  "Division": {
    definition: "Division is splitting a number into equal parts.",
    examples: [
      "Example 1: 12 / 4 = 3",
      "Example 2: 20 / 5 = 4"
    ],
    problem: {
      question: "What is 18 divided by 6?",
      solution: "18 / 6 = 3."
    }
  },

     "Even Numbers": {
      definition: "Even numbers are integers that are exactly divisible by 2.",
      examples: [
        "Example 1: 4 is an even number.",
        "Example 2: 12 is an even number."
      ],
      problem: {
        question: "Is 8 an even number?",
        solution: "Yes, 8 is an even number because it is divisible by 2."
      }
    },
    "Odd Numbers": {
      definition: "Odd numbers are integers that are not divisible by 2.",
      examples: [
        "Example 1: 5 is an odd number.",
        "Example 2: 11 is an odd number."
      ],
      problem: {
        question: "Is 7 an odd number?",
        solution: "Yes, 7 is an odd number because it is not divisible by 2."
      }
    },
    "Factors and Multiples": {
      definition: "A factor is a number that divides another number without leaving a remainder. A multiple is the product of a number and an integer.",
      examples: [
        "Example 1: 3 is a factor of 15.",
        "Example 2: 20 is a multiple of 4."
      ],
      problem: {
        question: "What are the factors of 12?",
        solution: "The factors of 12 are 1, 2, 3, 4, 6, and 12."
      }
    },
    "GCD (Greatest Common Divisor)": {
      definition: "The GCD of two or more numbers is the largest positive integer that divides each of the numbers without leaving a remainder.",
      examples: [
        "Example 1: The GCD of 8 and 12 is 4.",
        "Example 2: The GCD of 24 and 36 is 12."
      ],
      problem: {
        question: "What is the GCD of 18 and 24?",
        solution: "The GCD of 18 and 24 is 6."
      }
    },
    "LCM (Least Common Multiple)": {
      definition: "The LCM of two or more numbers is the smallest positive integer that is divisible by each of the numbers.",
      examples: [
        "Example 1: The LCM of 3 and 5 is 15.",
        "Example 2: The LCM of 6 and 8 is 24."
      ],
      problem: {
        question: "What is the LCM of 4 and 10?",
        solution: "The LCM of 4 and 10 is 20."
      }
    },


      "Variables": {
        definition: "In algebra, a variable is a symbol, usually a letter, that represents one or more numbers.",
        examples: [
          "Example 1: In the expression 2x + 3, x is a variable.",
          "Example 2: In the equation y = 4x - 7, both x and y are variables."
        ],
        problem: {
          question: "If x = 5, what is the value of 2x + 3?",
          solution: "Substitute x with 5: 2(5) + 3 = 10 + 3 = 13."
        }
      },
      "Expressions": {
        definition: "An algebraic expression is a combination of variables, numbers, and operators (such as +, -, *, /) without an equality sign.",
        examples: [
          "Example 1: 3x + 2 is an algebraic expression.",
          "Example 2: 4y - 5 is an algebraic expression."
        ],
        problem: {
          question: "Simplify the expression 2x + 3x - 4.",
          solution: "Combine like terms: 2x + 3x - 4 = 5x - 4."
        }
      },
      "Equations": {
        definition: "An equation is a mathematical statement that asserts the equality of two expressions. It contains an equality sign (=).",
        examples: [
          "Example 1: 2x + 3 = 7 is an equation.",
          "Example 2: 4y - 5 = 11 is an equation."
        ],
        problem: {
          question: "Solve the equation 2x + 3 = 7.",
          solution: "Subtract 3 from both sides: 2x = 4. Divide both sides by 2: x = 2."
        }
      },
      "Linear Equations": {
        definition: "A linear equation is an equation between two variables that gives a straight line when plotted on a graph. It is of the form ax + by = c.",
        examples: [
          "Example 1: y = 2x + 1 is a linear equation.",
          "Example 2: 3x - 4y = 12 is a linear equation."
        ],
        problem: {
          question: "Solve the linear equation 3x - 4y = 12 for y when x = 2.",
          solution: "Substitute x with 2: 3(2) - 4y = 12. Simplify: 6 - 4y = 12. Subtract 6 from both sides: -4y = 6. Divide both sides by -4: y = -1.5."
        }
      },
    
      
        "Shapes and Figures": {
          definition: "Shapes and figures are geometric forms that can be defined and measured.",
          examples: [
            "Example 1: A square has 4 equal sides and 4 right angles.",
            "Example 2: A circle is a shape with all points equidistant from the center."
          ],
          problem: {
            question: "How many sides does a hexagon have?",
            solution: "A hexagon has 6 sides."
          }
        },
        "Area and Perimeter": {
          definition: "The area is the amount of space inside a shape, while the perimeter is the distance around the shape.",
          examples: [
            "Example 1: The area of a rectangle is found using the formula: length x width.",
            "Example 2: The perimeter of a rectangle is found using the formula: 2(length + width)."
          ],
          problem: {
            question: "What is the area of a rectangle with length 5 and width 3?",
            solution: "The area of the rectangle is 5 x 3 = 15 square units."
          }
        },
        "Volume": {
          definition: "Volume is the amount of space a 3-dimensional object occupies.",
          examples: [
            "Example 1: The volume of a cube is found using the formula: side^3.",
            "Example 2: The volume of a cylinder is found using the formula: πr^2h."
          ],
          problem: {
            question: "What is the volume of a cube with side length 4?",
            solution: "The volume of the cube is 4^3 = 64 cubic units."
          }
        },
        "Angles": {
          definition: "An angle is formed by two rays with a common endpoint called the vertex.",
          examples: [
            "Example 1: A right angle is 90 degrees.",
            "Example 2: An acute angle is less than 90 degrees."
          ],
          problem: {
            question: "What is the measure of a straight angle?",
            solution: "A straight angle measures 180 degrees."
          }
        },
      
     
          "Length": {
            definition: "Length is a measure of how long something is from one end to the other.",
            examples: [
              "Example 1: The length of a pencil is 15 cm.",
              "Example 2: The height of a building is 50 meters."
            ],
            problem: {
              question: "Convert 5 meters to centimeters.",
              solution: "1 meter = 100 centimeters, so 5 meters = 5 x 100 = 500 centimeters."
            }
          },
          "Weight": {
            definition: "Weight is a measure of how heavy an object is.",
            examples: [
              "Example 1: The weight of an apple is 150 grams.",
              "Example 2: The weight of a bag of rice is 5 kilograms."
            ],
            problem: {
              question: "Convert 3 kilograms to grams.",
              solution: "1 kilogram = 1000 grams, so 3 kilograms = 3 x 1000 = 3000 grams."
            }
          },
          "Capacity": {
            definition: "Capacity is the amount of space that a container can hold.",
            examples: [
              "Example 1: A bottle has a capacity of 1 liter.",
              "Example 2: A swimming pool has a capacity of 2000 liters."
            ],
            problem: {
              question: "Convert 2 liters to milliliters.",
              solution: "1 liter = 1000 milliliters, so 2 liters = 2 x 1000 = 2000 milliliters."
            }
          },
          "Time": {
            definition: "Time is the ongoing sequence of events taking place.",
            examples: [
              "Example 1: There are 60 minutes in an hour.",
              "Example 2: A day has 24 hours."
            ],
            problem: {
              question: "Convert 3 hours to minutes.",
              solution: "1 hour = 60 minutes, so 3 hours = 3 x 60 = 180 minutes."
            }
          },
          "Money": {
            definition: "Money is a medium of exchange for goods and services.",
            examples: [
              "Example 1: A dollar is equal to 100 cents.",
              "Example 2: A euro is used in many European countries."
            ],
            problem: {
              question: "If you have 5 dollars and each apple costs 50 cents, how many apples can you buy?",
              solution: "1 dollar = 100 cents, so 5 dollars = 5 x 100 = 500 cents. Number of apples = 500 cents / 50 cents = 10 apples."
            }
          },
        
        
            "Data Collection and Representation": {
              definition: "Data collection is the process of gathering information. Data representation involves displaying data using charts, graphs, tables, etc.",
              examples: [
                "Example 1: Collecting data on the number of students in different classes and representing it using a bar graph.",
                "Example 2: Surveying people's favorite fruits and displaying the data using a pie chart."
              ],
              problem: {
                question: "Represent the following data using a bar graph: { 'A': 5, 'B': 7, 'C': 3 }.",
                solution: "Create a bar graph with categories A, B, and C on the x-axis and their corresponding values 5, 7, and 3 on the y-axis."
              }
            },
            "Mean, Median, and Mode": {
              definition: "Mean is the average of a set of numbers. Median is the middle value when the numbers are arranged in order. Mode is the number that appears most frequently.",
              examples: [
                "Example 1: The mean of 2, 3, 4 is (2+3+4)/3 = 3.",
                "Example 2: The median of 1, 3, 3, 6, 7 is 3."
              ],
              problem: {
                question: "Find the mode of the following numbers: 2, 4, 4, 6, 7.",
                solution: "The mode is 4 because it appears most frequently."
              }
            },
            "Probability": {
              definition: "Probability is the measure of the likelihood of an event occurring. It ranges from 0 (impossible) to 1 (certain).",
              examples: [
                "Example 1: The probability of flipping a coin and getting heads is 1/2.",
                "Example 2: The probability of rolling a 3 on a 6-sided die is 1/6."
              ],
              problem: {
                question: "What is the probability of drawing a red card from a standard deck of cards?",
                solution: "There are 26 red cards in a deck of 52 cards. Probability = 26/52 = 1/2."
              }
            },
          
      
              "Arithmetic Sequence": {
                definition: "An arithmetic sequence is a sequence of numbers in which the difference of any two successive members is a constant.",
                examples: [
                  "Example 1: 2, 4, 6, 8, 10 is an arithmetic sequence with a common difference of 2.",
                  "Example 2: 5, 9, 13, 17, 21 is an arithmetic sequence with a common difference of 4."
                ],
                problem: {
                  question: "What is the 5th term in the arithmetic sequence 3, 7, 11, ...?",
                  solution: "The common difference is 4. The 5th term = 3 + 4(5-1) = 3 + 16 = 19."
                }
              },
              "Geometric Sequence": {
                definition: "A geometric sequence is a sequence of numbers where each term after the first is found by multiplying the previous term by a fixed, non-zero number called the common ratio.",
                examples: [
                  "Example 1: 3, 6, 12, 24, 48 is a geometric sequence with a common ratio of 2.",
                  "Example 2: 5, 15, 45, 135 is a geometric sequence with a common ratio of 3."
                ],
                problem: {
                  question: "What is the 4th term in the geometric sequence 2, 6, 18, ...?",
                  solution: "The common ratio is 3. The 4th term = 2 * 3^(4-1) = 2 * 27 = 54."
                }
              },
            
              
                "Functions": {
                  definition: "A function is a relation between a set of inputs and a set of permissible outputs. Each input is related to exactly one output.",
                  examples: [
                    "Example 1: f(x) = 2x + 3 is a function.",
                    "Example 2: g(x) = x^2 - 4x + 7 is a function."
                  ],
                  problem: {
                    question: "If f(x) = 2x + 3, what is f(5)?",
                    solution: "Substitute x with 5: f(5) = 2(5) + 3 = 10 + 3 = 13."
                  }
                },
                "Graphs": {
                  definition: "Graphs are visual representations of data or functions, often used to illustrate relationships between variables.",
                  examples: [
                    "Example 1: A line graph showing the growth of a plant over time.",
                    "Example 2: A bar graph representing the number of students in different classes."
                  ],
                  problem: {
                    question: "Plot the function f(x) = x^2 on a graph.",
                    solution: "Create a table of values for x and f(x), then plot the points on a coordinate plane. Connect the points to form a parabola."
                  }
                },
                "Ratios": {
                  definition: "A ratio is a relationship between two numbers indicating how many times the first number contains the second.",
                  examples: [
                    "Example 1: The ratio of 2 to 3 is written as 2:3.",
                    "Example 2: The ratio of 5 to 10 is written as 1:2 after simplification."
                  ],
                  problem: {
                    question: "Simplify the ratio 8:12.",
                    solution: "Divide both numbers by their GCD (4): 8 ÷ 4 : 12 ÷ 4 = 2:3."
                  }
                },
                "Proportions": {
                  definition: "A proportion is an equation that states that two ratios are equal.",
                  examples: [
                    "Example 1: 1/2 = 2/4 is a proportion.",
                    "Example 2: 3/5 = 6/10 is a proportion."
                  ],
                  problem: {
                    question: "Is the proportion 4/6 = 2/3 true?",
                    solution: "Yes, 4/6 and 2/3 both simplify to 2/3, so the proportion is true."
                  }
                },
              
              
  

};

const Maths = () => {
  const [selectedTopic, setSelectedTopic] = useState("");

  const handleTopicChange = (e) => {
    setSelectedTopic(e.target.value);
  };

  const handleReadAloud = () => {
    const topic = topics[selectedTopic];
    const utterance = new SpeechSynthesisUtterance(topic.definition);
    speechSynthesis.speak(utterance);

    topic.examples.forEach((example) => {
      const exampleUtterance = new SpeechSynthesisUtterance(example);
      speechSynthesis.speak(exampleUtterance);
    });

    if (topic.problem) {
      const questionUtterance = new SpeechSynthesisUtterance(topic.problem.question);
      speechSynthesis.speak(questionUtterance);
      const solutionUtterance = new SpeechSynthesisUtterance(topic.problem.solution);
      speechSynthesis.speak(solutionUtterance);
    }
  };

  return (
    <div className="container">
      <h1>Math Basic Topics</h1>
      <select onChange={handleTopicChange} value={selectedTopic} className="topic-select">
        <option value="">Select Topic</option>
        {Object.keys(topics).map((topic, index) => (
          <option key={index} value={topic}>{topic}</option>
        ))}
      </select>
      {selectedTopic && (
        <div className="topic-details">
          <h2>{selectedTopic}</h2>
          <p>{topics[selectedTopic].definition}</p>
          <ul>
            {topics[selectedTopic].examples.map((example, index) => (
              <li key={index}>{example}</li>
            ))}
          </ul>
          {topics[selectedTopic].problem && (
            <div>
              <p><strong>Problem:</strong> {topics[selectedTopic].problem.question}</p>
              <p><strong>Solution:</strong> {topics[selectedTopic].problem.solution}</p>
            </div>
          )}
          <button onClick={handleReadAloud}>Read Aloud</button>
        </div>
      )}
    </div>
  );
};

export default Maths;
